import React from 'react'
import QcrLoader from './QcrLoader'

// Full-page loading overlay - QCR logo loader (1a "draws itself").
function LoadingGauge({mask}) {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-cream/[.75]'>
      <QcrLoader variant="draw" size={64} label="Loading" />
    </div>
  )
}

export default LoadingGauge
